'use strict';

const React = require('react'),
    { t } = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Loading = require('components/Commons/Loading/Loading'),
    Constants = require('constants/AppConstants'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    Notification = require('components/Notification/Notification'),
    InventoryStore = require('stores/InventoryStore'),
    NavigationUtils = require('utils/NavigationUtils'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    Authentication = require('services/Security').Authentication,
    ga = require('react-ga'),
    { map, filter, find, some } = require('lodash/collection'),
    { concat } = require('lodash/array'),
    get = require('lodash/object').get,
    { Navigation } = require('react-router'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');


const SaleItemAdmin = React.createClass({displayName: "SaleItemAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            saleId: NavigationUtils.getPathParam('sales'),
            name: NavigationUtils.getQueryParam('name'),
            customerId: NavigationUtils.getQueryParam('customerId'),
            code: NavigationUtils.getQueryParam('code'),
            isClosedOrder:
                NavigationUtils.getQueryParam('isClosed') !== 'false',
            comment: NavigationUtils.getQueryParam('comment'),
            selectedItem: null,
            isEditMode: false
        };
    },

    componentDidMount() {
        this.fetchSaleItems();
        ga.pageview('/sales-item-admin');
    },

    backToSales() {
        this.transitionTo('/sales/page/:page', { page: 0 });
    },

    fetchSaleItems(callBack) {
        const { saleId, customerId } = this.state;
        const self = this;
        InventoryStore.fetchFinishItems(function (items) {
            InventoryStore.fetchNonInventoryItems((nonInventoryItems) => {
                InventoryStore.fetchCustomerItems(customerId, function (customerItems) {
                    InventoryStore.fetchSaleItems(saleId, saleItems => {
                        self.setState(
                            {
                                saleItems: self._hydrateSaleItems(ContentUtils.filterEnable(saleItems)),
                                items: concat(adaptNonInventoryItemToVendorItem(nonInventoryItems), (ContentUtils.filterEnable(items))),
                                customerItems
                            },
                            () => {
                                if (callBack) {
                                    callBack();
                                }
                            }
                        );
                    });
                });
            });
        });
    },

    onDeleteSaleItem(saleItemId, onSuccess, onFailure) {
        const saleId = get(this.state, 'saleId');
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('sales_items_delete_confirmation'),
            () => {
                InventoryStore.deleteSaleItem(saleId, saleItemId, onSuccess, onFailure);
            }
        );
    },

    changeSaleItem(saleItem, onSuccess, onFailure) {
        saleItem.amount = NumberUtils.standardiseDecimalFormatNumber(saleItem.amount);
        InventoryStore.changeSaleItem(
            saleItem,
            onSuccess,
            onFailure
        );
        this.setState({
            preSelectedItem: null
        });
    },

    getCustomPrice() {
        const { selectedItem, preSelectedItem, items, customerItems, isEditMode } = this.state;
        const isNewMode = isEditMode === false;

        if (isNewMode) {
            const haveSelectedItemDropdown = ContentUtils.isNotNullOrUndefined(preSelectedItem);
            if (haveSelectedItemDropdown) {
                // enter here means is a new item, and the item was already
                // defined so we search the customer sale price of the item
                const customerItemTarget = find(customerItems, customerItem => get(customerItem, 'item.id') === get(preSelectedItem, 'id'));
                const haveCustomCustomerItem = ContentUtils.isNotNullOrUndefined(customerItemTarget);

                if (haveCustomCustomerItem) {
                    return get(customerItemTarget, 'salePrice') || '0';
                }

                // enter here means the customer items doesn't exist,
                // so we continue search to base price of item.
                const itemTarget = find(items, item => get(item, 'id') === get(preSelectedItem, 'id'));
                return get(itemTarget, 'salePrice') || '0';
            } else {
                return '0';
            }
        } else {
            // in change mode, just show the price already saved
            return get(selectedItem, 'customPriceUnit') || '0';
        }
    },

    addSaleItem(saleItem, onSuccess, onFailure) {
        saleItem.saleId = NavigationUtils.getPathParam('sales');
        saleItem.amount = NumberUtils.standardiseDecimalFormatNumber(saleItem.amount || '0');
        InventoryStore.addSaleItem(saleItem, onSuccess, onFailure);
        this.setState({
            preSelectedItem: null
        });
    },

    getBreadcrumbLinks() {
        return [
            { link: '/sales/page/0', displayName: t('sales_title') },
            { displayName: `${t('order')} #${NavigationUtils.getQueryParam('code')}` }
        ];
    },

    _confirmOrderDelivered() {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('sales_warning_after_this_confirmation_will_be_closed'),
            () => {
                const saleId = get(this.state, 'saleId');
                InventoryStore.confirmSaleOrderDelivered(
                    saleId,
                    this._onSuccessWhenTryDeliver,
                    this._onFailureWhenTryDeliver);
            }
        );
    },

    _onSuccessWhenTryDeliver() {
        this.transitionTo(
            '/sales/:saleId/items',
            {
                saleId: get(this.state, 'saleId')
            },
            {
                customerId: NavigationUtils.getQueryParam('customerId'),
                name: NavigationUtils.getQueryParam('name'),
                code: NavigationUtils.getQueryParam('code'),
                isClosed: true
            }
        );

        Notification.show(t('sales_order_was_sent'), 'success');

        setTimeout(() => {
            window.location.reload(true);
        }, 1500);
    },

    _onFailureWhenTryDeliver(messageInfo) {
        if (messageInfo) {
            const haveNotEnoughItemsToSell = messageInfo.includes('0009');
            if (haveNotEnoughItemsToSell) {
                CustomDialog.showInfo(
                    t('warning'),
                    ContentUtils.formatMessageError(messageInfo)
                );
            } else {
                const messageError = ContentUtils.formatMessageError(messageInfo);
                Notification.show(messageError);
            }
        }
    },


    _amountValidation(inputValue) {
        if (ContentUtils.isEmptyText(inputValue)) {
            return '';
        }

        let result = NumberUtils.isNumber(inputValue)
            ? ''
            : t('sales_items_amount_must_a_number');
        const isNumber = result === '';

        if (isNumber) {
            return NumberUtils.isGreater(inputValue, -1) ? ''
                : t('sales_items_could_not_negative');
        }

        return result;
    },

    _amountValidationNonZero(inputValue) {
        if (ContentUtils.isEmptyText(inputValue)) {
            return '';
        }

        if (NumberUtils.isEqual(inputValue, '0')) {
            return t('product_addition_inline_error_amount_must_be_greater_than_zero');
        }

        let result = NumberUtils.isNumber(inputValue)
            ? ''
            : t('sales_items_amount_must_a_number');
        const isNumber = result === '';

        if (isNumber) {
            return NumberUtils.isGreater(inputValue, -1) ? ''
                : t('sales_items_could_not_negative');
        }

        return result;
    },

    _commentValidation(comment) {
        if (ContentUtils.isEmptyText(comment)) {
            return '';
        }

        if (get(comment, 'length') >= 500) {
            return t('vendor_purchase_max_amount_characters');
        }

        return '';
    },

    _hydrateSaleItems(saleItems) {
        return map(ContentUtils.filterEnable(saleItems), saleItems => {
            saleItems.amountWithUnit = `${saleItems.amount} (${get(saleItems, 'item.unit', t('item_admin_column_unit'))})`;
            saleItems.customPriceUnitWithSymbol = `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(saleItems.customPriceUnit,get(SessionStore.getCurrentCurrencyDigits(), 'value')) || NumberUtils.formatDecimal('0',get(SessionStore.getCurrentCurrencyDigits(), 'value'))}`;
            saleItems.customTotalPriceUnitWithSymbol = `${NumberUtils.getCurrentCurrency().symbol} ${showTotalPrice(saleItems)}`;
            return saleItems;
        });
    },

    _saveComment() {
        InventoryStore.saveCommentOnlySaleOrder(this.state.saleId, this.state.comment !== "" ? this.state.comment : "null");
        Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + this.state.saleId + " " +  t('updated'), 'success')
    },

    _onChangeComment(sale){
        this.state.comment = sale.target.value !== "" ? sale.target.value : "null";
      },

    onChangeSelectedItem(preSelectedVendorItem) {
        if (preSelectedVendorItem) {
            this.setState(() => {
                return {
                    preSelectedItem: preSelectedVendorItem
                };
            });
        }
    },

    _onBlurSelectedItem(preSelectedVendorItem) {
        if (preSelectedVendorItem) {
            this.setState(prevState => {
                if (prevState.selectedItem) {
                    return {
                        preSelectedItem: Object.assign(
                            prevState.selectedItem,
                            preSelectedVendorItem
                        )
                    };
                } else {
                    return {
                        preSelectedItem: preSelectedVendorItem
                    };
                }
            });
        }
    },

    _onSuccessWhenSendEmailConfirmation() {
        Notification.show(t('sales_order_was_sent'), 'success');
        this.fetchSaleItems();
    },

    _onFailureWhenSendEmailToCustomer(messageInfo) {
        if (messageInfo) {
            const haveNotEmail = messageInfo.includes(Constants.ERROR_CODE_SALE_WITHOUT_CONTACT_EMAIL);
            if (haveNotEmail) {
                const self = this;
                CustomDialog.showWarningConfirmation(
                    t('warning'),
                    t('sales_items_failure_email_customer'),
                    () => {
                        self.transitionTo(
                            '/customers/:customerId/contacts',
                            {
                                customerId: NavigationUtils.getQueryParam('customerId')
                            },
                            {
                                name: get(self.state, 'selectedItem.customerName')
                            }
                        );
                    }
                );

            } else {
                const messageError = ContentUtils.formatMessageError(messageInfo);
                Notification.show(messageError);
            }
        }
    },

    _sendOrderToCustomer() {
        const self = this;
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('sales_customer_will_be_notified'),
            () => {
                const saleId = NavigationUtils.getPathParam('sales');
                InventoryStore.sendOrderToCustomer(saleId,
                    self._onSuccessWhenSendEmailConfirmation
                    , self._onFailureWhenSendEmailToCustomer);
            });
    },

    _printReport() {
        InventoryStore.downloadReportPDF(this.state.filter, 'sales/'+this.state.saleId);
      },

    render() {
        const { saleItems } = this.state;
        if (!saleItems) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('sales_items_change_success'),
                changeFailureMessage: t('sales_items_change_failure'),
                deleteSuccessMessage: t('sales_items_delete_succes'),
                addSuccessMessage: t('sales_items_add_success'),
                addFailureMessage: t('sales_items_add_failure')
            };
            const contextHolder = this.getContextHolderInstance();
            const {
                selectedItem,
                preSelectedItem,
                saleItems,
                isEditMode,
                items,
                isClosedOrder,
                code
            } = this.state;

            const hasAtLeastOneSaleItem = get(saleItems, 'length') > 0;
            const hasSomeNonNotified = some(saleItems, saleItem => get(saleItem, 'state') === Constants.SALE_ITEM_NON_NOTIFIED);
            let unit;

            if (selectedItem) {
                unit = getUnitFromVendorItem(selectedItem);
            } else {
                unit = getUnitFromVendorItem(preSelectedItem);
            }

            const unitWithParenthesis = unit ? '(' + unit + ')' : t('unit');
            const formFieldsEl = [
                React.createElement(FormGroupTextFieldSuggested, {
                    operationsHolder: contextHolder, 
                    items: items, 
                    readerAttribute: "description", 
                    readerAttributeValue: "id", 
                    writerAttribute: "itemId", 
                    itemsDisabled: filterItemsAlreadyInUse(
                        items,
                        saleItems
                    ), 
                    customErrorNonMatch: t('sales_items_error_non_match'), 
                    name: t('item'), 
                    isEditMode: isEditMode, 
                    isImmutable: true, 
                    label: t('item'), 
                    value: get(selectedItem, 'item') || preSelectedItem, 
                    onChange: this._onBlurSelectedItem, 
                    onBlur: this._onBlurSelectedItem}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "amount", 
                    additionalValidation: this._amountValidationNonZero, 
                    name: t('label_amount'), 
                    value: selectedItem, 
                    label: `${t('item')} ${unitWithParenthesis}`, 
                    isRelaxedText: true, 
                    isEditMode: isEditMode, 
                    isDecimalFormat: false, 
                    onEnter: this.__onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "customPriceUnit", 
                    additionalValidation: this._amountValidation, 
                    name: `${t('sales_items_custom_price')} ${unitWithParenthesis}`, 
                    value: { customPriceUnit: this.getCustomPrice()}, 
                    label: `${t('sales_items_custom_price')} ${unitWithParenthesis}`, 
                    isRelaxedText: true, 
                    isRequired: false, 
                    isDecimalFormat: true, 
                    isEditMode: isEditMode, 
                    onEnter: this.__onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "comment", 
                    name: t('order').charAt(0).toUpperCase() + t('order').slice(1) +" "+t('comment'), 
                    value: this.state, 
                    label: t('order').charAt(0).toUpperCase() + t('order').slice(1) +" "+t('comment'), 
                    additionalValidation: inputValue => this._commentValidation(inputValue), 
                    isRelaxedText: false, 
                    noInternalValidation: true, 
                    isEditMode: isEditMode, 
                    isRequired: false, 
                    onEnter: this._onEnterPress, 
                    onChange: this._onChangeComment, 
                    id: "comment"}
                )
            ];

            let additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('back'), 
                            icon: "subdirectory_arrow_left", 
                            type: "icon", 
                            onClick: this.backToSales}
                        )
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('back'), 
                            icon: "subdirectory_arrow_left", 
                            type: "icon", 
                            onClick: this.backToSales}
                        )
                    )
                },
                {
                    type: 'NEW',
                    permission: 'PRINT_REPORT',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('sales_print'), 
                            icon: "file_download", 
                            type: "icon", 
                            onClick: this._printReport}
                        )
                    )
                }
            ];

            if (hasAtLeastOneSaleItem && !isClosedOrder) {
                additionalButtons.push({
                    type: 'NEW',
                    permission: 'SEND_ORDER',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: hasSomeNonNotified ? t('sales_send_order') : t('sales_items_re_send_order'), 
                            icon: "send", 
                            type: "icon", 
                            onClick: this._sendOrderToCustomer}
                        )
                    )
                });
            }

            if (
                hasAtLeastOneSaleItem && // has some sale items
                !hasSomeNonNotified && // all items has been sent
                !isClosedOrder // is open order
            ) {
                additionalButtons.push({
                    type: 'NEW',
                    permission: 'SEND_ORDER',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('sales_confirm_deliver'), 
                            icon: "local_shipping", 
                            type: "icon", 
                            onClick: this._confirmOrderDelivered}
                        )
                    )
                });
            }

            if (
                hasAtLeastOneSaleItem && // has some sale items
                !isClosedOrder // is open order
            ) {
                additionalButtons.push({
                    type: 'CHANGE',
                    permission: 'CHANGE',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('button_label_save'), 
                            icon: "save", 
                            type: "icon", 
                            onClick: this.__onEnterPress}
                        )
                    )
                });
            }

            additionalButtons.push({
                type: 'NEW',
                permission: 'SAVE_COMMENT',
                el: (
                    React.createElement(FormGroupButton, {
                        label: t('button_label_save_comment'), 
                        icon: "save", 
                        type: "icon", 
                        onClick: this._saveComment}
                    )
                )
            });

            return (
                React.createElement(AdminScaffolding, {
                    messages: messages, 
                    moduleName: "ADMIN_SALE", 
                    onAddText: t('vendor_admin_label_associate'), 
                    onDeleteText: t('vendor_admin_label_disassociate'), 
                    onChangeText: t('button_label_save'), 
                    additionalButtons: additionalButtons, 
                    title: 
                        isClosedOrder
                            ? `${t('sales_items_sale_order')} #${code} ${t('closed')}`
                            : isEditMode ? t('sales_items_editing_item') : `${t('sales_items_editing_sales_order')} #${NavigationUtils.getQueryParam('code')}`, 
                    
                    contextHolder: contextHolder, 
                    value: selectedItem, 
                    fetchItems: this.fetchSaleItems, 
                    headerFields: formFieldsEl, 
                    onAdd: 
                        isClosedOrder
                            ? undefined
                            : this.addSaleItem, 
                    
                    onChange: 
                        isClosedOrder
                            ? undefined
                            : this.changeSaleItem, 
                    
                    onCancel: this.__onCancel, 
                    onDelete: 
                        isClosedOrder
                            ? undefined
                            : this.onDeleteSaleItem, 
                    
                    addEnterKeyDown: this.__addEnterKeyDown, 
                    breadcrumb: this.getBreadcrumbLinks(), 
                    isDark: true
                }, 
                    React.createElement(AdminScaffoldingTable, {
                        sortByColumn: "item.name", 
                        onRowSelection: this.__onRowSelection, 
                        value: selectedItem, 
                        filteredColumns: [
                            'item.description',
                            'amountWithUnit',
                            'customPriceUnitWithSymbol',
                            'customTotalPriceUnitWithSymbol'
                        ], 
                        displayAttributes: [
                            'item.description',
                            'amountWithUnit',
                            'customPriceUnitWithSymbol',
                            'customTotalPriceUnitWithSymbol',
                        ], 
                        columnNames: [
                            t('sales_items_column_name'),
                            t('sales_items_column_amount'),
                            t('sales_items_column_price'),
                            t('sales_column_total_price')
                        ]
                    }, 
                        saleItems
                    )
                )
            );
        }
    }
});

function filterItemsAlreadyInUse(items, selectedItems) {
    const itemIdsAlreadyInUse =
        map(selectedItems, selectedItem => get(selectedItem, 'item.id')) || [];
    const itemsFiltered = filter(items, item =>
        itemIdsAlreadyInUse.includes(get(item, 'id'))
    );
    const itemsMarked = map(itemsFiltered, item => {
        item.isDisabled = true;
        return item;
    });

    return itemsMarked;
}

function getUnitFromVendorItem(vendorItem) {
    return get(vendorItem, 'item.unit') || get(vendorItem, 'unit');
}

function showTotalPrice(saleItems) {
    return NumberUtils.formatDecimal(NumberUtils.multiply(saleItems.customPriceUnit, saleItems.amount || 1) || NumberUtils.formatDecimal('0'),get(SessionStore.getCurrentCurrencyDigits(), 'value'));
}

function adaptNonInventoryItemToVendorItem(nonInventoryItems = []) {
    return map(nonInventoryItems, nonInventoryItem => {
        nonInventoryItem.item = {
            id: nonInventoryItem.id,
            description: nonInventoryItem.description
        };
        nonInventoryItem.minimumOrder = 1;
        return nonInventoryItem;
    });
}

module.exports = SaleItemAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/SalesAdmin/SalesItemsAdmin.jsx
 **/